(() => {
  const topParent = document.querySelector(".header__progressbar");
  // The html that would use these would normally not be nested in the top parent. They would be outside in a button for example.
  if (topParent) {
    const incrementButton = document.querySelectorAll(
      ".header__progressbar__increment"
    );

    const decrementButton = document.querySelectorAll(
      ".header__progressbar__decrement"
    );

    const headerProgressbarIncrementIndex = () => {
      const currCompletedIndex = parseInt(
        topParent?.getAttribute("data-completed-items") || "0"
      );
      updateAttribute(currCompletedIndex + 1);
    };

    const headerProgressbarDecrementIndex = () => {
      const currCompletedIndex = parseInt(
        topParent?.getAttribute("data-completed-items") || "0"
      );
      let value = currCompletedIndex;
      if (currCompletedIndex > 0) {
        value = currCompletedIndex - 1;
      }
      updateAttribute(value);
    };
    const updateAttribute = (updatedValue) => {
      topParent?.setAttribute("data-completed-items", updatedValue);
    };

    incrementButton.forEach((buttonIncr) => {
      buttonIncr?.addEventListener("click", headerProgressbarIncrementIndex);
    });
    decrementButton.forEach((buttonDecr) => {
      buttonDecr?.addEventListener("click", headerProgressbarDecrementIndex);
    });
  }
})();
